module.exports = __webpack_public_path__ + "static/img/start-line3.4a1e9b62.svg";